import * as React from 'react';
import InputLabel from '@material-ui/core/InputLabel';

import {
	Root,
	ContentLayout,
	SwitchLayout,
	Circle,
	ChekedIconLayout,
	UnchekedIconLayout,
	Sign,
	LabelLayout,
} from './styled';


type SwitchProps = {
	value: boolean;
	label?: React.ReactNode;
	disabled?: boolean;
	withHelperText?: boolean;
	onChange: (e: React.SyntheticEvent, value: boolean) => void;
}

const Switch: React.SFC<SwitchProps> = (props) => {
	const {
		value,
		label,
		disabled,
		withHelperText,
		onChange
	} = props;
	const handleClick = React.useCallback((e: React.SyntheticEvent) => !disabled && onChange(e, !value), [value, disabled]);
	const handleKeyDown = React.useCallback((e: React.KeyboardEvent) => {
		if (e.key === 'Enter') {
			!disabled && onChange(e, !value);
		}
	}, [value, disabled]);

	return (
		<Root>
			{
				label &&
				<LabelLayout>
					<InputLabel shrink>{label}</InputLabel>
				</LabelLayout>
			}
			<ContentLayout>
				{
					withHelperText &&
					<Sign isActive={value}>выкл.</Sign>
				}
				<SwitchLayout
					tabIndex={0}
					isActive={value}
					disabled={disabled}
					withLabels={withHelperText}
					onClick={handleClick}
					onKeyDown={handleKeyDown}>
					<ChekedIconLayout>
						o
					</ChekedIconLayout>
					<Circle isActive={value} />
					<UnchekedIconLayout>
						x
					</UnchekedIconLayout>
				</SwitchLayout>
				{
					withHelperText &&
					<Sign isActive={!value}>вкл.</Sign>
				}
			</ContentLayout>
		</Root>
	);
}

Switch.displayName = 'Switch';
Switch.defaultProps = {
	withHelperText: false
};

export default Switch;
